import { cva } from 'class-variance-authority';

export const cvaRoot = cva(['FeaturesPopupStyles-cvaRoot', 'fixed z-[200] left-0 top-0', 'w-full h-full']);

export const cvaOverlay = cva([
  'FeaturesPopup-cvaOverlay',
  'absolute left-0 top-0',
  'w-full h-full',
  'bg-cBlack bg-opacity-[0.32]',
]);

export const cvaAside = cva([
  'FeaturesPopup-cvaAside',
  'absolute right-0 top-0',
  'w-[56rem] h-screen',
  'bg-cWhite',
  'rounded-tl-[3.2rem]',
]);

export const cvaAsideHeader = cva([
  'FeaturesPopup-cvaAsideHeader',
  'py-4.8 pb-3.2 px-8',
  'bg-cLightGrey',
  'rounded-tl-[3.2rem]',
]);

export const cvaAsideBody = cva(['FeaturesPopup-cvaAsideBody', 'py-3.2 px-8']);

export const cvaAsideScroll = cva(['FeaturesPopup-cvaAsideScroll', 'overflow-auto', 'h-full']);

export const cvaTitle = cva(['FeaturesPopup-cvaTitle', 'text-h3 font-secondary', 'not-last:mb-2.4']);

export const cvaDescr = cva([
  'FeaturesPopup-cvaDescr',
  'text-bodyM text-cBlack text-opacity-[0.64]',
  'not-last:mb-2.4',
]);

export const cvaIconWrapper = cva(['FeaturesPopup-cvaIconWrapper', 'relative', 'w-7.2 h-7.2']);

export const cvaIcon = cva(['FeaturesPopup-cvaIcon', 'object-contain object-center']);

export const cvaList = cva(['FeaturesPopup-cvaList', '[counter-reset:count]']);

export const cvaItem = cva([
  'FeaturesPopup-cvaItem',
  'relative',
  'pl-4.8',
  'not-last:mb-2.4',
  'text-bodyM text-cBlack text-opacity-80',
  '[counter-increment:count]',
  'before:[content:counter(count)_!important] before:absolute before:left-0 before:-top-0.4 before:w-3.2 before:h-3.2 before:rounded-full',
  'before:text-bodyM before:bg-cLightGreenBtn before:text-cMediumGreen before:flex before:items-center before:justify-center',
]);

export const cvaClose = cva([
  'FeaturesPopup-cvaClose',
  'flex items-center justify-center',
  'absolute top-1.6 md:top-4 right-full mr-3.2 z-[10]',
  'w-4 md:w-5.6 h-4 md:h-5.6',
  'bg-cWhite',
  'rounded-[1.2rem] md:rounded-[1.6rem]',
  'cursor-pointer select-none',
  'transition-colors duration-300',
  'group',
]);

export const cvaCloseIcon = cva([
  'FeaturesPopup-cvaCloseIcon',
  'w-1.6 h-1.6',
  '[&>path]:stroke-cBlack',
  '[&>path]:ransition-colors [&>path]:duration-300',
]);
